import React from "react";
import { pageTitle } from "../../helpers/PageTitle";

export default function PrivacyPolicy() {
  pageTitle("Privacy Policy");
  return (
    <div style={{ margin: "80px auto", padding: 24, paddingTop: "80px" }}>
      <style>
        {`
          h1 {
            text-align: center;
          }
          h2 {
            margin-top: 30px;
            margin-bottom: 15px;
            font-size: 25px;
          }
          ul {
            margin-left: 20px;
          }
          .privacy-content {
            margin-top: 80px;
            padding-left: 50px;
            margin: 80px auto;
          }
          .effective-date {
            font-weight: bold;
            font-size: 18px;
          }
          .email-link {
            color: white;
            text-decoration: none;
          }
            @media screen and (max-width: 991px) {
    body, html {
        font-size: 16px;
        line-height: 1.6em;
    }
         h2 {
           font-size: 18px;
          }
           h1 {
    font-size: 29px;
}
    .privacy-content {
    margin-top: 80px;
    padding-left: 0px;
    }

        `}
      </style>
      <h1>Privacy Policy</h1>
      <div className="privacy-content">
        <p className="effective-date">Effective Date: Sunday, 22 June 2025</p>
        
        <p>
          At Ignite Sports Pavilion, your privacy is important to us. This Privacy Policy outlines how we collect, use, store, and protect your personal information when you use our website or services.
        </p>

        <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>1. Information We Collect</h2>
        <ul style={{ marginLeft: "20px" }}>
          <li><strong>Personal Information:</strong> Name, email, phone number, and any other details provided during booking or registration.</li>
          <li><strong>Usage Data:</strong> Pages visited, time spent on the site, and interaction data.</li>
          <li><strong>Payment Details:</strong> When applicable, processed securely via third-party payment gateways.</li>
        </ul>

        <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>2. How We Use Your Information</h2>
        <ul style={{ marginLeft: "20px" }}>
          <li>To process bookings and provide our services</li>
          <li>To send updates, promotions, or event notifications</li>
          <li>To improve our website and user experience</li>
        </ul>

        <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>3. Sharing of Information</h2>
        <p>
          We do not sell or rent your personal information. We may share your data with:
        </p>
        <ul style={{ marginLeft: "20px" }}>
          <li>Trusted third-party service providers for operational support</li>
          <li>Legal authorities when required by law</li>
        </ul>

        <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>4. Data Security</h2>
        <p>
          We implement industry-standard measures to protect your data from unauthorized access, disclosure, or misuse.
        </p>

        <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>5. Your Rights</h2>
        <p>
          You can request access, correction, or deletion of your personal data by contacting us at{" "}
          <a href="mailto:info@ignitesportspavilion.com" style={{ color: "white", textDecoration: "none" }}>
            info@ignitesportspavilion.com
          </a>
        </p>

        <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>6. Changes to This Policy</h2>
        <p>
          We may update this policy occasionally. Changes will be posted on this page with the updated effective date.
        </p>
      </div>
    </div>
  );
} 